module.exports = __webpack_public_path__ + "static/media/georgeIdBannerLogo.190ea442.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/georgeIdBannerLogo.svg
// module id = 212
// module chunks = 21